import { render, staticRenderFns } from "./TermOfUse.vue?vue&type=template&id=15d35d7b&scoped=true"
import script from "./TermOfUse.vue?vue&type=script&lang=js"
export * from "./TermOfUse.vue?vue&type=script&lang=js"
import style0 from "./TermOfUse.vue?vue&type=style&index=0&id=15d35d7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d35d7b",
  null
  
)

export default component.exports